import { type CanonicalSchema, deepFreeze, CanonicalFieldType as T } from './canonical-schema.js'

/**
 * `conversion@1` — owned by the customer bounded context (customer-service,
 * TO-405). One record is one contracted product of a customer, matched by the
 * customer's `externalId`; fields follow Epic 03 Story 10 minus the free-form
 * `attributes`. APPEND-ONLY: never edit this published version; publish
 * `conversion.v2.ts` instead.
 */
export const CONVERSION_V1: CanonicalSchema = deepFreeze({
	name: 'conversion',
	version: 1,
	owner: 'customer',
	fields: [
		{ name: 'customerExternalId', type: T.STRING, required: true, nullable: false, maxLength: 128 },
		{ name: 'contractedAt', type: T.DATETIME, required: true, nullable: false, maxLength: null },
		{ name: 'contractRef', type: T.STRING, required: false, nullable: true, maxLength: 128 },
		{ name: 'productCode', type: T.STRING, required: false, nullable: true, maxLength: 64 },
		{ name: 'productName', type: T.STRING, required: false, nullable: true, maxLength: 200 },
		{ name: 'productCategory', type: T.STRING, required: false, nullable: true, maxLength: 64 },
		{ name: 'contractAmount', type: T.DECIMAL, required: false, nullable: true, maxLength: null },
		{ name: 'contractCurrency', type: T.STRING, required: false, nullable: true, maxLength: 3 },
		{ name: 'channel', type: T.STRING, required: false, nullable: true, maxLength: 32 },
		{ name: 'offerId', type: T.STRING, required: false, nullable: true, maxLength: 36 },
	],
})
